//#region Asset Imports

import * as _ from 'underscore'

//#endregion

//#region Angular Imports

import { StateService } from "@uirouter/angularjs"

//#endregion

//#region DevExtreme Imports

import 'devextreme/ui/tooltip'

//#endregion

import { CorrelationType } from '../../../helpers/common-helper';
import { EventsNames } from '../../../helpers/events-names';
import { DashboardTileDataModel } from '../../api/api.models';
import { Enums } from '../../../models/common';
import { SystemService, SYSTEM_SERVICE_NAME } from '../../../services/system';

//#region Asset Imports

import './tile.scss'
import * as TEMPLATE from './tile.tpl.html'

//#endregion

enum TileInternalItem {
    Title = 0,
    Value = 1,
    Icon = 2
}

interface TileGridsterItem {
    sizeX: number
    sizeY: number
    col: number
    row: number
    visible: boolean
    value: any
    type: number
    position: {
        horisontal: string,
        vertical: string
    },
    fontSize?: number
    fontColor?: string
    iconStretch?: number
}

interface TileScope extends ng.IScope {
    id: number
    data: DashboardTileDataModel
    action: () => void
    iconType: string
    style: any,
    backgroundImage: string
    borderRadius: string
    border: string
    boxShadow: string
    isEditMode: boolean
    bgColor: string
    dynamicFontSize: number

    tileGridsterOptions: any
    tileInternalItems: TileGridsterItem[]
    isEditGridster: boolean
}

export class TileDirective implements ng.IDirective {
    private clickTimer: any
    private gridsterItems: TileGridsterItem[]

    private gridsterMaxRows: number = 12
    private gridsterXMargin: number = 0
    private gridsterYMargin: number = 5

    constructor() {

    }
    scope = {
        data: '=',
        itemTitle: '=',
        isEditMode: '=',
    }

    controller = ['$scope', '$timeout', '$state', SYSTEM_SERVICE_NAME, ($scope: TileScope, $timeout: ng.ITimeoutService, $state: StateService, systemService: SystemService) => {
        $scope.action = null
        $scope.id = Date.now()
        const extensionRegex: RegExp = /(?:\.([^.]+))?$/


        let getGridsterRowHeight = (): number => {
            return (angular.element(document.querySelector('#tileGridster' + $scope.id)).height() - this.gridsterXMargin) / this.gridsterMaxRows
        }

        let getHorisontalPosition = (pos: number): string => {
            let position: string = 'center'
            switch (pos) {
                case Enums.Alignment.Center:
                case Enums.Alignment.Left:
                case Enums.Alignment.Right:
                    position = 'center'
                    break
                case Enums.Alignment.Bottom:
                case Enums.Alignment.BottomLeft:
                case Enums.Alignment.BottomRight:
                    position = 'flex-end'
                    break
                case Enums.Alignment.Top:
                case Enums.Alignment.TopLeft:
                case Enums.Alignment.TopRight:
                    position = 'flex-start'
                    break
            }

            return position
        }

        let getVerticalPosition = (pos: number): string => {
            let position: string = 'center'
            switch (pos) {
                case Enums.Alignment.Center:
                case Enums.Alignment.Bottom:
                case Enums.Alignment.Top:
                    position = 'center'
                    break
                case Enums.Alignment.Left:
                case Enums.Alignment.BottomLeft:
                case Enums.Alignment.TopLeft:
                    position = 'flex-start'
                    break
                case Enums.Alignment.Right:
                case Enums.Alignment.TopRight:
                case Enums.Alignment.BottomRight:
                    position = 'flex-end'
                    break
            }

            return position
        }

        /**remove unnecessary data and stringify gridster items settings */
        let stringifyItems = (items: TileGridsterItem[]): string => {
            items.forEach((item: TileGridsterItem) => {
                delete item.fontColor
                delete item.fontSize
                delete item.position
                delete item.value
                delete item.visible
                delete item.iconStretch
            })
            return JSON.stringify(items)
        }

        let prepareGridsterOptions = (): void => {
            let gridsterItems: TileGridsterItem[] = []
            if ($scope.data.gridsterSettings) {
                gridsterItems = JSON.parse($scope.data.gridsterSettings)
            }

            if (gridsterItems.length) {
                gridsterItems.forEach((row: TileGridsterItem) => {
                    if (row.type === TileInternalItem.Title) {
                        row.visible = $scope.data.texHeaderVisible
                        row.value = $scope.data.textHeader ? $scope.data.textHeader.description : null
                        row.position = {
                            horisontal: getHorisontalPosition($scope.data.titlePosition),
                            vertical: getVerticalPosition($scope.data.titlePosition)
                        }
                        row.fontSize = $scope.data.titleSize
                        row.fontColor = $scope.data.titleColor
                    }
                    if (row.type === TileInternalItem.Value) {
                        row.visible = $scope.data.amountVisible
                        row.value = $scope.data.value || 0
                        row.position = {
                            horisontal: getHorisontalPosition($scope.data.valuePosition),
                            vertical: getVerticalPosition($scope.data.valuePosition)
                        }
                        row.fontSize = $scope.data.valueSize
                        row.fontColor = $scope.data.valueColor
                    }
                    if (row.type === TileInternalItem.Icon) {
                        row.visible = $scope.data.iconVisible
                        row.value = $scope.data.icon ? $scope.data.icon.fileBytesObj : null
                        row.type = TileInternalItem.Icon
                        row.position = {
                            horisontal: getHorisontalPosition($scope.data.iconPosition),
                            vertical: getVerticalPosition($scope.data.iconPosition)
                        }
                        row.iconStretch = $scope.data.iconStretch
                    }
                })
            }
            else {
                gridsterItems = [{
                    sizeX: 12,
                    sizeY: 4,
                    col: 0,
                    row: 0,
                    visible: $scope.data.texHeaderVisible,
                    value: $scope.data.textHeader ? $scope.data.textHeader.description : '',
                    type: TileInternalItem.Title,
                    position: {
                        horisontal: getHorisontalPosition($scope.data.titlePosition),
                        vertical: getVerticalPosition($scope.data.titlePosition)
                    },
                    fontSize: $scope.data.titleSize,
                    fontColor: $scope.data.titleColor
                }, {

                    sizeX: 12,
                    sizeY: 4,
                    col: 0,
                    row: 4,
                    visible: $scope.data.amountVisible,
                    value: $scope.data.value,
                    type: TileInternalItem.Value,
                    position: {
                        horisontal: getHorisontalPosition($scope.data.valuePosition),
                        vertical: getVerticalPosition($scope.data.valuePosition)
                    },
                    fontSize: $scope.data.valueSize,
                    fontColor: $scope.data.valueColor
                }, {
                    sizeX: 12,
                    sizeY: 4,
                    col: 0,
                    row: 8,
                    visible: $scope.data.iconVisible,
                    value: $scope.data.icon ? $scope.data.icon.fileBytesObj : null,
                    type: TileInternalItem.Icon,
                    position: {
                        horisontal: getHorisontalPosition($scope.data.iconPosition),
                        vertical: getVerticalPosition($scope.data.iconPosition)
                    },
                    iconStretch: Enums.Stretch.None
                }]
            }

            $scope.tileInternalItems = gridsterItems
            $scope.data.gridsterSettings = stringifyItems($scope.tileInternalItems.map((item: TileGridsterItem) => _.assign({}, item)))

            $scope.tileGridsterOptions = {
                minRows: 1, // the minimum height of the grid, in rows
                maxRows: this.gridsterMaxRows,
                columns: 12, // the width of the grid, in columns
                colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                rowHeight: getGridsterRowHeight(),// 'match', // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                margins: [this.gridsterXMargin, this.gridsterYMargin], // the pixel distance between each widget
                defaultSizeX: 1, // the default width of a gridster item, if not specifed
                defaultSizeY: 1, // the default height of a gridster item, if not specified
                mobileBreakPoint: 10, // if the screen is not wider that this, remove the grid layout and stack the items
                resizable: {
                    enabled: $scope.isEditGridster,
                    start: function (event, uiWidget, $element) {
                    }, // optional callback fired when resize is started,
                    resize: function (event, uiWidget, $element) {

                    }, // optional callback fired when item is resized,
                    stop: function (event, uiWidget, $element) {
                        $scope.data.gridsterSettings = stringifyItems($scope.tileInternalItems.map(item => _.assign({}, item)))
                    } // optional callback fired when item is finished resizing
                },
                draggable: {
                    enabled: $scope.isEditGridster, // whether dragging items is supported
                    //handle: '.ddd', // optional selector for resize handle
                    start: function (event, uiWidget, $element) {
                    }, // optional callback fired when drag is started,
                    drag: function (event, uiWidget, $element) {
                    }, // optional callback fired when item is moved,
                    stop: function (event, uiWidget, $element) {
                        $scope.data.gridsterSettings = stringifyItems($scope.tileInternalItems.map(item => _.assign({}, item)))
                    } // optional callback fired when item is finished dragging
                }

            }
        }

        let setDynamicFontSize = _.debounce(() => {
            if ($scope.data.titleSize) {
                $scope.dynamicFontSize = null
            } else {
                $scope.dynamicFontSize = angular.element(document.querySelector('#tileGridster' + $scope.id)).parent().width() / 20
            }
        }, 500)

        let createTile = () => {
            if ($scope.data) {
                if ($scope.data.iconVisible && $scope.data.icon) {
                    if ($scope.data.icon.extension == "Unknown" && $scope.data.icon.physicalFileName) {
                        const ext: string = extensionRegex.exec($scope.data.icon.physicalFileName)[1]
                        if (ext && ext.toLowerCase() == 'svg') $scope.iconType = 'svg+xml'
                    } else if ($scope.data.icon.extension == "Png") {
                        $scope.iconType = 'png'
                    } else if ($scope.data.icon.extension == "Svg") {
                        $scope.iconType = 'svg+xml'
                    } else {
                        $scope.iconType = 'png'
                    }
                }

                if ($scope.data.backgroundImage) {
                    if ($scope.data.backgroundImage.extension == "Unknown" && $scope.data.backgroundImage.physicalFileName) {
                        const ext: string = extensionRegex.exec($scope.data.backgroundImage.physicalFileName)[1]
                        if (ext && ext.toLowerCase() == 'svg') $scope.backgroundImage = "url('data:image/svg+xml;base64," + $scope.data.backgroundImage.fileBytesObj + "')"
                    } else if ($scope.data.backgroundImage.extension == "Png") {
                        $scope.backgroundImage = "url('data:image/png;base64," + $scope.data.backgroundImage.fileBytesObj + "')"
                    } else if ($scope.data.backgroundImage.extension == "Svg") {
                        $scope.backgroundImage = "url('data:image/svg+xml;base64," + $scope.data.backgroundImage.fileBytesObj + "')"
                    } else {
                        $scope.backgroundImage = "url('data:image/png;base64," + $scope.data.backgroundImage.fileBytesObj + "')"
                    }
                } else {
                    $scope.backgroundImage = "none"
                }

                // border
                if ($scope.data.borderRadius && $scope.data.borderRadius.length > 0) {
                    $scope.borderRadius = $scope.data.borderRadius.map(r => r + 'px').join(' ')
                } else {
                    $scope.borderRadius = '0px'
                }

                $scope.border = ($scope.data.borderWidth ? $scope.data.borderWidth : 0) + 'px solid ' + ($scope.data.borderColor ? $scope.data.borderColor : '#000000')

                // box shadow
                let boxShadow: string = ''

                if ($scope.data.shadowHorizontalLenght) boxShadow += $scope.data.shadowHorizontalLenght + 'px '
                else boxShadow += '0px '

                if ($scope.data.shadowVerticalLenght) boxShadow += $scope.data.shadowVerticalLenght + 'px '
                else boxShadow += '0px '

                if ($scope.data.shadowBlurRadius) boxShadow += $scope.data.shadowBlurRadius + 'px '
                else boxShadow += '0px '

                if ($scope.data.shadowSpreadRadius) boxShadow += $scope.data.shadowSpreadRadius + 'px '
                else boxShadow += '0px '

                if ($scope.data.shadowColor) boxShadow += $scope.data.shadowColor
                else boxShadow += 'rgba(0,0,0,0.8)'

                $scope.boxShadow = boxShadow
                // end of box shadow

                if ($scope.data.referenceData) {
                    $scope.action = () => {
                        if (!$scope.isEditGridster) {
                            if ($scope.data.correlationType === CorrelationType.None) {
                                systemService.openDetailsOrModule({
                                    idReferenceType: $scope.data.referenceType,
                                    referenceObjectIds: $scope.data.referenceData
                                })
                            }
                            if ($scope.data.correlationType === CorrelationType.Local) {
                                if (this.clickTimer) {
                                    //doubleclick
                                    clearTimeout(this.clickTimer)
                                    this.clickTimer = null

                                    systemService.openDetailsOrModule({
                                        idReferenceType: $scope.data.referenceType,
                                        referenceObjectIds: $scope.data.referenceData
                                    })
                                } else {
                                    this.clickTimer = setTimeout(() => {
                                        //click
                                        $scope.$root.$broadcast(EventsNames.DASHBOARD_TILE_CLICKED, $scope.data.referenceData, $scope.data.referenceType)
                                        this.clickTimer = null
                                    }, 250)
                                }
                            }
                        }
                    }
                }

                setTimeout(() => {
                    prepareGridsterOptions()
                })

                setDynamicFontSize()
            }
            else {
                $scope.data = <any>{}
                $scope.data['isTemplate'] = true
            }
        }

        createTile()

        $scope.$on(EventsNames.UPDATE_DASHBOARD_ITEM + $scope.data.id, (event, ...args: any[]) => {
            if (_.first(args) != null) {
                $scope.data = _.first(args)
            }
            createTile()
            $scope.bgColor = $scope.data.backgroundColor
        })

        $scope.$on(EventsNames.DASHBOARD_MAP_MARKERS_COUNT_CHANGED, (event: ng.IAngularEvent, ...args: any[]) => {
            const referenceValues: any[] = args[0] || []
            const referenceType: number = args[1]
            const correlationType: number = $scope.data.correlationType

            if (correlationType === CorrelationType.Local) {
                if ($scope.data.referenceType === referenceType) {
                    $scope.data.value = referenceValues.length
                    if ($scope.tileInternalItems) {
                        $scope.tileInternalItems.forEach((item: TileGridsterItem) => {
                            if (item.type === TileInternalItem.Value) {
                                item.value = referenceValues.length
                            }
                        })
                    }
                }
            }
        })

        $scope.$on(EventsNames.DASHBOARD_TILE_GRIDSTER_EDIT + $scope.data.id, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.isEditGridster = args[0]
            setTimeout(() => {
                createTile()
            })
        })

        $scope.$watch(() => angular.element(document.querySelector('#tileGridster' + $scope.id)).height(), _.debounce((val: any) => {
            createTile()
        }, 1000))

        $scope.$watch(() => angular.element(document.querySelector('#tileGridster' + $scope.id)).width(), _.debounce((val: any) => {
            createTile()
        }, 1000))
    }]

    restrict = 'E'
    template = TEMPLATE
    transclude = true
    replace = true
}